var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hiq-search-app__header"},[_c('h1',[_vm._v(_vm._s(((_vm.translations.searchResultFor) + " '" + _vm.query + "'")))])])}
var staticRenderFns = []

export { render, staticRenderFns }